var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fsvgicon",class:_vm.classes,style:(_vm.styles),attrs:{"aria-hidden":_vm.ariaHidden}},[_c('span',{staticClass:"fsvgicon-icon",style:(_vm.iconStyles)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }